import DashboardApi from "../api/service/dashboard/DashboardApi";

export default class DashboardService {
    api;

    constructor() {
        this.api = new DashboardApi();
    }

    async getTopTenShops({ today }) {
        return this.api.getTopTenShops({ today }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getBookmarkedShops() {
        return this.api.getBookmarkedShops().then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getTopThreeSales({ today }) {
        return this.api.getTopThreeSales({ today }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }
}
